import { cn } from "@/lib/utils";
import { ComponentProps, forwardRef } from "react";

export const UnstyledButton = forwardRef<HTMLButtonElement, ComponentProps<"button">>(
  ({ className, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(
        "all-unset font-family-inherit box-border block cursor-pointer bg-none",
        className,
      )}
      {...props}
    />
  ),
);
